import { Modal } from '@mui/material'
import { InputField, SelectField, Button } from 'cwp-components/forms'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

type AddNewOfficeProps = {
  open: boolean
  setModal: any
}

export const AddNewOfficeModal = ({ open, setModal }: AddNewOfficeProps) => {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    trigger,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  const [isChecked, setIsChecked] = useState<boolean>(false)

  const handleChange = () => {
    setIsChecked(!isChecked)
  }

  const onSubmit = () => {
    return
  }

  return (
    <Modal
      className='backdrop-blur-[12.5px] flex justify-center items-center w-full h-full'
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          setModal(false)
        }
      }}
      disableAutoFocus={false}
      disableEnforceFocus={false}
      disableRestoreFocus={false}
    >
      <div className=' p-[15px_10px_25px_10px] mx-[10px] md:w-[800px] bg-white'>
        <div className='flex justify-end'>
          <svg
            onClick={() => setModal(false)}
            className='cursor-pointer'
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M18 6L6 18'
              stroke='#020251'
              stroke-width='3'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M6 6L18 18'
              stroke='#020251'
              stroke-width='3'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </svg>
        </div>
        <div className='md:p-[30px] p-[10px]'>
          <div className='md:p-[0px_30px_20px_30px] p-[0px_15px_10px_15px]  text-center mb-[26px]'>
            <h1 className='text-[#003831] text-[24px] font-bold '>
              Add new office
            </h1>
          </div>
          <form action='' onSubmit={handleSubmit(onSubmit)}>
            <div className='grid grid-cols-2 md:gap-[26px] gap-[8px]'>
              <div className='flex flex-col item-center space-y-[12px]'>
                <SelectField
                  register={register}
                  id='officeType'
                  placeholder='officeType'
                  required={true}
                  errorMessage='This field is mandatory. Please enter the requested information.'
                  errors={errors}
                  label='Office Type'
                  records={['Branch', 'HQ']}
                />
                <InputField
                  register={register}
                  id='websiteUrl'
                  label={`Website URL`}
                  placeholder={`websiteUrl`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='addressLine1'
                  label={`Address line 1`}
                  placeholder={`addressLine1`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='addressLine2'
                  label={`Address line 2`}
                  placeholder={`addressLine2`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='addressLine3'
                  label={`Address line 3`}
                  placeholder={`addressLine3`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='country'
                  label={`County`}
                  placeholder={`country`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='country'
                  label={`Country`}
                  placeholder={`country`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
              </div>
              <div className='flex flex-col item-center space-y-[12px]'>
                {/* <SelectField records={[]} /> */}
                <InputField
                  register={register}
                  id='emailAddress'
                  label={`Email address`}
                  placeholder={`emailAddress`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='town'
                  label={`Town`}
                  placeholder={`town`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='postCode'
                  label={`Postcode`}
                  placeholder={`postCode`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='phoneNumber'
                  label={`Phone Number`}
                  placeholder={`phoneNumber`}
                  className='!h-[44px]'
                  labelSize='10px'
                  required={true}
                  errors={errors}
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='latitude'
                  label={`Latitude`}
                  placeholder={`latitude`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
                <InputField
                  register={register}
                  id='longitude'
                  label={`Longitude`}
                  placeholder={`longitude`}
                  className='!h-[44px]'
                  required={true}
                  errors={errors}
                  labelSize='10px'
                  errorMessage='This field is mandatory. Please enter the requested information.'
                />
              </div>
            </div>
            <div className='flex justify-end'>
              <Button onClick={handleChange}>Continue</Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}
